import { render, staticRenderFns } from "./DetailWhatsAppAlert.vue?vue&type=template&id=d6ec25d4"
import script from "./DetailWhatsAppAlert.vue?vue&type=script&lang=js"
export * from "./DetailWhatsAppAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports